const angular = require('angular')

const getQueryParams = function(url, name) {
  const result = {}
  const reg = /[?&][^?&#]+=[^?&#]+/g
  const queryList = url.match(reg) || []
  for (let i = 0; i < queryList.length; i++) {
    const item = queryList[i]
    const temp = item.substring(1).split('=')
    const key = decodeURIComponent(temp[0])
    const value = decodeURIComponent(temp[1])
    result[key] = value
  }
  return name ? result[name] : result
}
// 生成随机的字符串作为模态框标识
const randomString = function(len) {
  len = len || 6
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  const maxPos = $chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

module.exports = ['$q', '$ionicHistory', '$ionicModal', '$rootScope', '$location', function($q, $ionicHistory, $ionicModal, $rootScope, $location) {
  const getModalQuery = function(url) {
    let urlQuery = getQueryParams(url)
    urlQuery = angular.extend({
      modalID: '',
      modalParams: JSON.stringify({})
    }, urlQuery)
    urlQuery.modalID = String(urlQuery.modalID)
    urlQuery.modalParams = JSON.parse(urlQuery.modalParams)
    return urlQuery
  }
  const setModalQuery = function(modalQuery, curQuery) {
    curQuery = curQuery || {
      modalID: '',
      modalParams: {}
    }
    modalQuery = angular.extend(curQuery, modalQuery)
    modalQuery.modalID = String(modalQuery.modalID)
    modalQuery.modalParams = JSON.stringify(modalQuery.modalParams)
    $location.search(modalQuery)
  }
  // state变化判断是否需要隐藏modal
  $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
    const currentView = $ionicHistory.currentView()
    if (!currentView || !currentView.phoneModal) return

    angular.forEach(currentView.phoneModal, phoneModal => {
      phoneModal.isShown() && phoneModal.hide()
    })
  })
  // 模态框的searchQuery变化判断是否需要隐藏modal
  $rootScope.$on('$locationChangeStart', function (event, toUrl, fromUrl) {
    if (toUrl === fromUrl) return

    const toUrlQuery = getModalQuery(toUrl)
    const fromUrlQuery = getModalQuery(fromUrl)
    if (toUrlQuery.modalID === fromUrlQuery.modalID) return

    const currentView = $ionicHistory.currentView()
    if (!currentView || !currentView.phoneModal) return

    if (toUrlQuery.modalID) {
      const phoneModal = currentView.phoneModal[toUrlQuery.modalID]
      phoneModal && !phoneModal.isShown() && phoneModal.show()
    }

    if (fromUrlQuery.modalID) {
      const phoneModal = currentView.phoneModal[fromUrlQuery.modalID]
      phoneModal && phoneModal.isShown() && phoneModal.hide()
    }

    // 返回到路由的根视图则不需要显示任何modal
    !toUrlQuery.modalID && angular.forEach(currentView.phoneModal, phoneModal => {
      phoneModal.isShown() && phoneModal.hide()
    })
  })

  return {
    /**
     * @ngdoc method
     * @name $ionicModal#fromTemplate
     * @param {string} templateString The template string to use as the modal's
     * content.
     * @param {object} options Options to be passed {@link ionic.controller:ionicModal#initialize ionicModal#initialize} method.
     * @returns {object} An instance of an {@link ionic.controller:ionicModal}
     * controller.
     */
    fromTemplate: function(templateString, options) {
      const ionicModal = $ionicModal.fromTemplate(templateString, options)
      const phoneModal = ionicModal
      phoneModal.originShow = ionicModal.show
      phoneModal.originRemove = ionicModal.remove
      phoneModal.show = function() {
        const modalId = phoneModal.scope ? phoneModal.scope.$id : randomString()
        const currentView = $ionicHistory.currentView()
        if (currentView) {
          currentView.phoneModal = currentView.phoneModal || {}
          currentView.phoneModal[modalId] = phoneModal
          // setModalQuery({modalID: modalId}, getModalQuery($location.absUrl()))
        }
        phoneModal.originShow()
      }
      phoneModal.remove = function() {
        if (phoneModal.__isRemoved) return

        phoneModal.__isRemoved = true
        phoneModal.originRemove()
      }
      return phoneModal
    },
    /**
     * @ngdoc method
     * @name $ionicModal#fromTemplateUrl
     * @param {string} templateUrl The url to load the template from.
     * @param {object} options Options to be passed {@link ionic.controller:ionicModal#initialize ionicModal#initialize} method.
     * options object.
     * @returns {promise} A promise that will be resolved with an instance of
     * an {@link ionic.controller:ionicModal} controller.
     */
    fromTemplateUrl: function(url, options, _) {
      const deferred = $q.defer()
      $ionicModal.fromTemplateUrl(url, options, _).then(function(ionicModal) {
        const phoneModal = ionicModal
        phoneModal.originShow = ionicModal.show
        phoneModal.originRemove = ionicModal.remove
        phoneModal.show = function() {
          const modalId = phoneModal.scope ? phoneModal.scope.$id : randomString()
          const currentView = $ionicHistory.currentView()
          if (currentView) {
            currentView.phoneModal = currentView.phoneModal || {}
            currentView.phoneModal[modalId] = phoneModal
            // setModalQuery({modalID: modalId}, getModalQuery($location.absUrl()))
          }
          phoneModal.originShow()
        }
        phoneModal.remove = function() {
          phoneModal.__isRemoved = true
          phoneModal.originRemove()
        }
        deferred.resolve(phoneModal)
      })
      return deferred.promise
    },

    stack: $ionicModal.stack,
    getModalQuery: getModalQuery,
    setModalQuery: setModalQuery
  }
}]



// WEBPACK FOOTER //
// ./src/js/services/phoneModal.js